<div class="custom">
  <div class="modal-header with-subtitle">
    <h5 class="modal-title">
      {{ 'pricingPlan.updatePaymentMethod' | transloco }}
    </h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancel()"></button>
  </div>

  <div class="modal-body pt-3 pb-2">
    <div class="payment-component-wrapper" [class.is-processing]="isProcessing$ | async">
      <div id="payment-component"></div>

      @if (isProcessing$ | async) {
        <div class="payment-processing-overlay">
          <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
          <p class="payment-processing-message">{{ 'payment.processingMessage' | transloco }}</p>
        </div>
      }
    </div>
  </div>

  <div class="d-flex justify-content-end align-items-center p-3 sticky-total">
    <button
      class="btn btn-primary btn-card-action ms-3"
      [disabled]="isProcessing$ | async"
      (click)="onConfirm()"
    >
      {{ 'common.controls.update' | transloco }}
    </button>
  </div>
</div>
